// import db from 'utils/localstorage'

// export default {
//   namespaced: true,
//   state: {
//     sidebar: {
//       opened: true
//     },
//     settingBar: {
//       opened: false
//     },
//     isMobile: false,
//     theme: db.get('THEME', 'light'),
//     layout: db.get('LAYOUT', 'side'),
//     // systemName: '农村土地确权综合应用平台',
//     systemName: '农业补贴管理系统',
//     copyright: `${new Date().getFullYear()} <a  target="_blank">HIT</a>`,
//     multipage: getBooleanValue(db.get('MULTIPAGE'), true),
//     fixSiderbar: getBooleanValue(db.get('FIX_SIDERBAR'), true),
//     fixHeader: getBooleanValue(db.get('FIX_HEADER'), true),
//     colorList: [
//       'rgb(245, 34, 45)',
//       'rgb(250, 84, 28)',
//       'rgb(250, 173, 20)',
//       'rgb(66, 185, 131)',
//       'rgb(82, 196, 26)',
//       'rgb(24, 144, 255)',
//       'rgb(47, 84, 235)',
//       'rgb(114, 46, 209)'
//     ],
//     color: db.get('COLOR', 'rgb(24, 144, 255)')
//   },
//   mutations: {
//     setDevice (state, isMobile) {
//       state.isMobile = isMobile
//     },
//     setTheme (state, theme) {
//       db.save('THEME', theme)
//       state.theme = theme
//     },
//     setLayout (state, layout) {
//       db.save('LAYOUT', layout)
//       state.layout = layout
//     },
//     setMultipage (state, multipage) {
//       db.save('MULTIPAGE', multipage)
//       state.multipage = multipage
//     },
//     setSidebar (state, type) {
//       state.sidebar.opened = type
//     },
//     fixSiderbar (state, flag) {
//       db.save('FIX_SIDERBAR', flag)
//       state.fixSiderbar = flag
//     },
//     fixHeader (state, flag) {
//       db.save('FIX_HEADER', flag)
//       state.fixHeader = flag
//     },
//     setSettingBar (state, flag) {
//       state.settingBar.opened = flag
//     },
//     setColor (state, color) {
//       db.save('COLOR', color)
//       state.color = color
//     }
//   }
// }

// function getBooleanValue (value, defaultValue) {
//   if (Object.is(value, null)) {
//     return defaultValue
//   }
//   if (JSON.stringify(value) !== '{}') {
//     return value
//   } else {
//     return false
//   }
// }
import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: true
    },
    settingBar: {
      opened: false
    },
    isMobile: false,
    theme: db.get('THEME', 'light'),
    layout: db.get('LAYOUT', 'side'),
    systemName: '农村土地确权综合应用平台',
    platform: db.get('PLATFORM'), // 设置登录平台
    unified: db.get('UNIFIED'), // 设置统一用户登录参数
    // copyright: `${new Date().getFullYear()} <a  target="_blank">HIT</a>`,
    copyright: `${new Date().getFullYear()} 农投大数据科技公司`,
    multipage: getBooleanValue(db.get('MULTIPAGE'), true),
    fixSiderbar: getBooleanValue(db.get('FIX_SIDERBAR'), true),
    fixHeader: getBooleanValue(db.get('FIX_HEADER'), true),
    colorList: [
      'rgb(245, 34, 45)',
      'rgb(250, 84, 28)',
      'rgb(250, 173, 20)',
      'rgb(66, 185, 131)',
      'rgb(82, 196, 26)',
      'rgb(24, 144, 255)',
      'rgb(47, 84, 235)',
      'rgb(114, 46, 209)'
    ],
    color: db.get('COLOR', 'rgb(24, 144, 255)')
  },
  mutations: {
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      db.save('THEME', theme)
      state.theme = theme
    },
    setLayout (state, layout) {
      db.save('LAYOUT', layout)
      state.layout = layout
    },
    setMultipage (state, multipage) {
      db.save('MULTIPAGE', multipage)
      state.multipage = multipage
    },
    setSidebar (state, type) {
      state.sidebar.opened = type
    },
    fixSiderbar (state, flag) {
      db.save('FIX_SIDERBAR', flag)
      state.fixSiderbar = flag
    },
    fixHeader (state, flag) {
      db.save('FIX_HEADER', flag)
      state.fixHeader = flag
    },
    setSettingBar (state, flag) {
      state.settingBar.opened = flag
    },
    setColor (state, color) {
      db.save('COLOR', color)
      state.color = color
    },
    setPlatform (state, platformName) {
      db.save('PLATFORM', platformName)
      state.platform = platformName
    },
    setUnified (state, unified) {
      db.save('UNIFIED', unified)
      state.unified = unified
    }
  }
}

function getBooleanValue (value, defaultValue) {
  if (Object.is(value, null)) {
    return defaultValue
  }
  if (JSON.stringify(value) !== '{}') {
    return value
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js